import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Sidebar from "./components/Sidebar/Sidebar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Skills from "./components/Skills/Skills";
import Contact from "./components/Contact/Contact";
import Menubar from "./components/MenuBar/Menubar";
import Experience from "./components/Experience/Experience";
import Projects from "./components/Projects/Projects";

const App = () => {
  return (
    <Router>
      <div className="d-flex">
        <div className="sidebar" style={{ width: "300px" }}>
          <Sidebar />
        </div>

        <div className="main-content" style={{ flex: 1 }}>
          <Menubar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;
